import React, { Fragment } from 'react';
import { Translate } from 'react-redux-i18n';
import HeaderComponent from '../../components/table/header/headerComponent';
import LiveTab from './components/LiveTab';
import HistoryTab from './components/HistoryTab';
import JourneyTab from './components/JourneyTab';

class AnalyticsPage extends React.PureComponent {
  state = { live: false, history: true, journey: false };

  setPage = (page) => {
    this.setState({
      live: page === 'live',
      history: page === 'history',
      journey: page === 'journey',
    });
  };

  render() {
    const { live, history, journey } = this.state;

    return (
      <div className="main-table">
        <div className="main-header-table">
          <HeaderComponent title={<Translate value="analytics" />} />
          <Fragment>
            <nav>
              <div
                className="nav nav-tabs"
                id="nav-tab"
                role="tablist"
                style={{ background: 'white' }}
              >
                <button
                  type="button"
                  className={`nav-item nav-link ${history ? 'active' : ''}`}
                  id="nav-analytics-history-tab"
                  data-toggle="tab"
                  role="tab"
                  aria-controls="nav-analytics-history"
                  aria-selected={history}
                  onClick={() => this.setPage('history')}
                >
                  <Translate value="analyticsHistory" />
                </button>
                <button
                  type="button"
                  className={`nav-item nav-link ${live ? 'active' : ''}`}
                  id="nav-analytics-live-tab"
                  data-toggle="tab"
                  role="tab"
                  aria-controls="nav-analytics-live"
                  aria-selected={live}
                  onClick={() => this.setPage('live')}
                >
                  <Translate value="analyticsLive" />
                </button>
                <button
                  type="button"
                  className={`nav-item nav-link ${journey ? 'active' : ''}`}
                  id="nav-analytics-journey-tab"
                  data-toggle="tab"
                  role="tab"
                  aria-controls="nav-analytics-journey"
                  aria-selected={journey}
                  onClick={() => this.setPage('journey')}
                >
                  <Translate value="analyticsJourney" />
                </button>
              </div>
            </nav>
            <div className="tab-content" id="nav-tabContent">
              <div
                className={`tab-pane fade ${history ? 'show active' : ''}`}
                id="nav-analytics-history"
                role="tabpanel"
                aria-labelledby="nav-analytics-history-tab"
              >
                {history && <HistoryTab />}
              </div>
              <div
                className={`tab-pane fade ${live ? 'show active' : ''}`}
                id="nav-analytics-live"
                role="tabpanel"
                aria-labelledby="nav-analytics-live-tab"
              >
                {live && <LiveTab />}
              </div>
              <div
                className={`tab-pane fade ${journey ? 'show active' : ''}`}
                id="nav-analytics-journey"
                role="tabpanel"
                aria-labelledby="nav-analytics-journey-tab"
              >
                {journey && <JourneyTab />}
              </div>
            </div>
          </Fragment>
        </div>
      </div>
    );
  }
}

export default AnalyticsPage;
